module.exports = __webpack_public_path__ + "img/glazing_1200x800.87588a4e.svg";